import LanguagesTemplate from '../../resources/handlebars/rebrand2020/language-selector/languages.hbs';

Hop.defineModule('language-selector-modal', (domRoot, param) => {
    let languageSelectorState = {};

    const DomHelper = {
        addSelectedClass: function (node) {
            node.classList.add('selected');
        },
        removeSelectedClass: function (node) {
            node.classList.remove('selected');
        },
        getSaveButtonNode: function () {
            return domRoot.querySelector('#language-selector-save');
        },
        getCountryNodeList: function () {
            return domRoot.querySelector('#languageSelectorModal .countries').querySelectorAll('.country');
        },
        getLanguageNodeList: function (filters) {
            let additionnalQuerySelector = '';

            if (filters) {
                additionnalQuerySelector += filters.excludeSelectedNodes === true ? ':not(.selected)' : '';
            }

            return domRoot.querySelector('#languageSelectorModal .languages').querySelectorAll('.language' + additionnalQuerySelector);
        },
        toggleSelectedClass: function (node, nextCode) {
            if (node.getAttribute('data-value') === nextCode) {
                DomHelper.addSelectedClass(node);
            } else {
                DomHelper.removeSelectedClass(node);
            }
        },
        updateCountriesSelection: function (nextCountryCode) {
            this.getCountryNodeList().forEach((node) => {
                this.toggleSelectedClass(node, nextCountryCode);
            });
        },
        updateLanguagesSelection: function (nextLanguageCode) {
            this.getLanguageNodeList().forEach((node) => {
                this.toggleSelectedClass(node, nextLanguageCode);
            });
        },
        disableSaveButton: function () {
            this.getSaveButtonNode().disabled = true;
        },
        enableSaveButton: function () {
            this.getSaveButtonNode().disabled = false;
        },
    };

    const WindowLocationHelper = {
        init: function () {
            const newUrl = new window.Url();

            let fixUrl = false;

            if (newUrl.query['x-auth'] !== undefined) {
                delete newUrl.query['x-auth'];
                fixUrl = true;
            }

            if (fixUrl) {
                if (window.history && typeof window.history.replaceState === 'function') {
                    history.replaceState(history.state, window.title, '' + newUrl);
                } else {
                    window.location.href = newUrl;
                }
            }
        },
        changeLocation: function (newLocaleCode) {
            const newUrl = new window.Url();

            newUrl.query.lg = newLocaleCode;
            window.location.href = newUrl;
        },
    };

    const ParamHelper = {
        getCountryByCode: function (countryCode) {
            const country = param.platformCountriesJson.filter((item) => item.countryCode === countryCode);
            return country.length === 1 ? country[0] : null;
        },
        getLanguageByCode: function (country, languageCode) {
            const language = country.platformLanguageHosts.filter((item) => item.language === languageCode);
            return language.length === 1 ? language[0] : null;
        },
    };

    function init() {
        languageSelectorState = getInitialState();
        WindowLocationHelper.init();
        DomHelper.disableSaveButton();
        registerLanguageSelectorModalEventListeners();
    }

    function getInitialState() {
        const currentCountry = param.currentCountryCode ? ParamHelper.getCountryByCode(param.currentCountryCode) : null;
        const currentLanguage =
            currentCountry && param.currentLanguageCode ? ParamHelper.getLanguageByCode(currentCountry, param.currentLanguageCode) : null;

        return {
            currentCountry,
            currentLanguage,
            selectedCountry: currentCountry,
            selectedLanguage: currentLanguage,
        };
    }

    function registerLanguageSelectorModalEventListeners() {
        registrerSaveButtonClickEventListener();
        registerCountryClickEventListener();
        registerLanguageClickEventListener();
    }

    function registrerSaveButtonClickEventListener() {
        DomHelper.getSaveButtonNode().addEventListener('click', handleSaveClick);
    }

    function registerCountryClickEventListener() {
        const countryNodeList = DomHelper.getCountryNodeList();

        countryNodeList.forEach((countryNode) => {
            countryNode.addEventListener('click', handleCountryClick);
        });
    }

    function registerLanguageClickEventListener() {
        const languageNodeList = DomHelper.getLanguageNodeList();

        languageNodeList.forEach((countryNode) => {
            countryNode.addEventListener('click', handleLanguageClick);
        });
    }

    function unregisterLanguageSelectorModalEventListeners() {
        unregisterCountryClickEventListener();
        unregisterLanguageClickEventListener();
        unregisterSaveButtonClickEventListener();
    }

    function unregisterSaveButtonClickEventListener() {
        DomHelper.getSaveButtonNode().removeEventListener('click', handleSaveClick);
    }

    function unregisterCountryClickEventListener() {
        DomHelper.getCountryNodeList().forEach((countryNode) => {
            countryNode.removeEventListener('click', handleCountryClick);
        });
    }

    function unregisterLanguageClickEventListener() {
        DomHelper.getLanguageNodeList().forEach((languageNode) => {
            languageNode.removeEventListener('click', handleLanguageClick);
        });
    }

    function handleSaveClick() {
        applyLanguageSelection();
    }

    function handleCountryClick(e) {
        const currentTargetNode = e.currentTarget;

        if (!currentTargetNode.classList.contains('selected')) {
            const nextCountryCode = currentTargetNode.getAttribute('data-value');
            if (nextCountryCode) {
                const nextCountry = ParamHelper.getCountryByCode(nextCountryCode);
                if (nextCountry !== null) {
                    DomHelper.disableSaveButton();
                    selectCountry(nextCountry);

                    unregisterLanguageClickEventListener();
                    renderLanguages(nextCountry, languageSelectorState.currentCountry.countryCode, languageSelectorState.currentLanguage.language);
                    registerLanguageClickEventListener();
                }
            }
        }
    }

    function selectCountry(nextCountry) {
        DomHelper.updateCountriesSelection(nextCountry.countryCode);

        languageSelectorState.selectedCountry = nextCountry;
    }

    function renderLanguages(nextCountry, currentCountryCode, currentLanguageCode) {
        domRoot.querySelector('#languageSelectorModal .languages').innerHTML = LanguagesTemplate({
            hosts: nextCountry.platformLanguageHosts,
            currentLanguageCode: currentCountryCode === nextCountry.countryCode ? currentLanguageCode : '',
        });
    }

    function handleLanguageClick(e) {
        const currentTargetNode = e.currentTarget;

        if (!currentTargetNode.classList.contains('selected')) {
            const nextLanguageCode = currentTargetNode.getAttribute('data-value');

            if (nextLanguageCode) {
                const nextLanguage = ParamHelper.getLanguageByCode(languageSelectorState.selectedCountry, nextLanguageCode);
                if (nextLanguage !== null) {
                    if (nextLanguage.locale !== languageSelectorState.currentLanguage.locale) {
                        DomHelper.enableSaveButton();
                    } else {
                        DomHelper.disableSaveButton();
                    }
                    selectLanguage(nextLanguage);
                }
            }
        }
    }

    function selectLanguage(nextLanguage) {
        DomHelper.updateLanguagesSelection(nextLanguage.language);
        languageSelectorState.selectedLanguage = nextLanguage;
    }

    function applyLanguageSelection() {
        WindowLocationHelper.changeLocation(languageSelectorState.selectedLanguage.locale);
    }

    init();

    return function destroy() {
        unregisterLanguageSelectorModalEventListeners();

        // Restore modal to its initial state (with current country and language selection)
        selectCountry(languageSelectorState.currentCountry);
        renderLanguages(
            languageSelectorState.currentCountry,
            languageSelectorState.currentCountry.countryCode,
            languageSelectorState.currentLanguage.language,
        );
    };
});
